import UserDropDown from "@/components/ui/UserDropDown";
import { Link } from "react-router-dom";

const WalletHeader = () => {
  return (
    <div className="hidden md:flex  border-b border-[#DFDFDF] justify-between py-4 px-4 md:pl-12 md:pr-6">
      <div className="flex items-center justify-between w-full">
        <div>
          <div className="flex gap-2 items-center">
            <h2 className="text-body-medium font-medium text-[#101828]">
              Wallet
            </h2>
          </div>
          <p className="text-caption-large text-gray-500 mt-1">
            Easily create and manage orders here.
          </p>
        </div>
        <div className="flex items-center gap-x-4">
          <UserDropDown />
        </div>
      </div>
    </div>
  );
};

export default WalletHeader;
